import Http from "./chatapp-http";

class MessageStatus extends Http {
  updateMessageStatus(msId, data) {
    return this.client.put(msId, data)
  }
  setConversationsRead(chatRoomId){
    return this.client.put(`/seen/chatroom/${chatRoomId}`)
  }
  getUnreadMessageLength(){
    return this.client.get('/has/unseen')
  }
}
const messageStatus = new MessageStatus({
  modelUrlPrefix : "messagestatus"
});

export default messageStatus;